"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManager_1 = require("../ApiManager");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiLayer = /** @class */ (function (_super) {
    __extends(ApiLayer, _super);
    function ApiLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.LAYER_URL = '/api/v1/layer/freeComicByRanking';
        /**
         * banner
         * @param request
         * @returns
         */
        _this.freeComicByRanking = function (token) {
            return ApiConfig_1.Axios.Client({
                method: 'get',
                url: _this.LAYER_URL,
                header: {
                    token: token,
                },
            });
        };
        return _this;
    }
    ApiLayer.getInstance = function (initValue) {
        if (!ApiLayer.classInstance) {
            this.classInstance = new ApiLayer(initValue);
        }
        return this.classInstance;
    };
    return ApiLayer;
}(ApiManager_1.ApiManager));
exports.default = ApiLayer;
